import type { ReactNode } from 'react'
import { IconArrowLeft } from '@tabler/icons-react'
import { useUnsavedGuard } from '../../../lib/unsavedChanges'
import { useI18n } from '../../../lib/i18n'

export function ProjectSettingsLayout({
  title,
  description,
  onBack,
  backLabel,
  stacked = false,
  children,
}: {
  title: string
  description: string
  /**
   * Vuelta al índice de Configuración.
   *
   * Opcional porque no todas estas pantallas cuelgan de él: algunas se abren
   * desde el menú lateral y ahí no hay ningún sitio al que volver.
   */
  onBack?: (() => void) | undefined
  /** Por defecto, «Volver a Configuración». Se resuelve abajo: aquí no hay traductor todavía. */
  backLabel?: string
  /**
   * Una sola columna, con la cabecera encima del contenido en vez de a un lado.
   *
   * El reparto normal —copia de apoyo a la izquierda, tarjetas editables a la
   * derecha— es el de una pantalla de ajustes. No sirve cuando la pantalla es
   * una acción sola y centrada: ahí el título es el encabezado de esa acción y
   * partirlo a un lado deja el centro de la página vacío.
   */
  stacked?: boolean
  children: ReactNode
}) {
  /* Volver con cambios sin guardar no se los lleva por delante: hace parpadear
     la barra de Guardar de arriba. Va aquí y no en cada pantalla porque este
     marco es el que dibuja el botón de volver de todas ellas. */
  const { t } = useI18n()
  const blockUnsaved = useUnsavedGuard()

  return (
    <div className={`dash-project-general-layout${stacked ? ' dash-project-general-layout--stacked' : ''}`}>
      <header className="dash-project-general-intro">
        {onBack ? (
          <button type="button" className="dash-secondary-btn dash-settings-back" onClick={() => { if (!blockUnsaved()) onBack() }}>
            <IconArrowLeft size={14} /> {backLabel ?? t('config.back')}
          </button>
        ) : null}
        <div className="dash-header">
          <h1>{title}</h1>
          <p>{description}</p>
        </div>
      </header>
      <div className="dash-project-general-content">{children}</div>
    </div>
  )
}
